import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import BlogPostSSR from '../../startup/BlogPostSSR.tsx';

ReactOnRails.register({BlogPostSSR});